import type { SortingState } from "@tanstack/react-table";
import type { ServerTableColumnFilters } from "./buildServerColumnFilters";

export type TableSortParams = {
  orderBy: string;
  orderDirection: "asc" | "desc";
};

export type TableRequestPayloadInput = {
  slugName: string;
  tableKey: string;
  organization?: string;
  user: unknown;
  component: unknown;
  filters: Record<string, string[]>;
  columnFilters?: ServerTableColumnFilters;
  archived: string;
  page: number;
  pageSize: number;
  sorting?: SortingState;
};

/** Map TanStack table sorting to collection list API query params. */
export function buildTableSortParams(
  sorting: SortingState | undefined | null
): TableSortParams | undefined {
  const first = Array.isArray(sorting) && sorting.length > 0 ? sorting[0] : null;
  if (!first?.id) return undefined;
  const orderBy = String(first.id).trim();
  if (!orderBy) return undefined;
  return {
    orderBy,
    orderDirection: first.desc ? "desc" : "asc",
  };
}

export function buildTableListPagination(page: number, pageSize: number) {
  return { page: Math.max(1, page), limit: Math.max(1, pageSize) };
}

export function buildTableRequestPayload(input: TableRequestPayloadInput) {
  const sort = buildTableSortParams(input.sorting);
  return {
    slugName: input.slugName,
    tableKey: input.tableKey,
    organization: input.organization,
    user: input.user,
    component: input.component,
    filters: input.filters,
    columnFilters: input.columnFilters,
    archived: input.archived,
    pagination: buildTableListPagination(input.page, input.pageSize),
    ...(sort ? { sort } : {}),
  };
}
